export default __webpack_public_path__ + "static/2467-8c009816cd64935f069287a4fb88f988.jpg";